<div class="rollup-company-page records-page datatable-page-shell">
    <div class="records-page__hero rollup-company-hero" *ngIf="!showReportOnly">
        <div class="records-page__hero-primary">
            <div class="records-page__hero-headline">
                <span class="records-page__hero-eyebrow">{{ 'ROLLUP_REPORT' | translate }}</span>
                <h3 class="records-page__hero-title">{{ companyData.name || ('ROLLUP_REPORT' | translate) }}</h3>
            </div>
        </div>
    </div>

    <div class="details-tab-surface rollup-company-filters datatable-page-surface" *ngIf="!showReportOnly">
        <form [formGroup]="reportForm" (submit)="onFormSubmit()" class="rollup-company-form">
            <div *ngIf="!isEmptyCompanyGuid" class="row g-3 align-items-center mb-3 rollup-form-row">
                <label class="col-12 col-xl-2 mb-2 rollup-form-label">{{ 'COMPANY_NAME' | translate }}</label>
                <div class="col-12 col-xl-10 rollup-form-value">{{ companyData.name }}</div>
            </div>
            <div class="row g-3 align-items-center mb-3 rollup-form-row rollup-form-row--dates">
                <label class="col-12 col-xl-2 mb-2 rollup-form-label">{{ 'SELECT_REPORT_PERIOD' | translate }}</label>
                <div class="col-12 col-xl-10">
                    <div class="rollup-date-fields">
                        <div class="rollup-period-select">
                            <ng-select
                                [clearable]="false"
                                class="mb-2"
                                [attr.aria-label]="'SELECT_PERIOD' | translate"
                                [placeholder]="'SELECT_PERIOD' | translate"
                                [items]="reportPeriods"
                                bindLabel="title"
                                bindValue="key"
                                formControlName="key"
                                (change)="onReportPeriodChange($event)">
                            </ng-select>
                        </div>
                        <div class="rollup-date-range">
                            <div class="rollup-date-input">
                                <label class="sr-only" for="startDate">{{ 'START' | translate }}</label>
                                <input type="date" [readonly]="datesReadonly" formControlName="startDate"
                                    class="form-control form-date date-custom mb-2"
                                    [ngClass]="{ 'is-invalid': reportformsubmitted && reportForm.controls.startDate.errors }" />

                                <div *ngIf="reportformsubmitted && reportForm.controls.startDate.errors" class="invalid-feedback">
                                    <div *ngIf="reportForm.controls.startDate.errors.required">{{ 'SELECT_PERIOD' | translate }}</div>
                                </div>
                            </div>
                            <div class="rollup-date-dash" aria-hidden="true">-</div>
                            <div class="rollup-date-input">
                                <label class="sr-only" for="stopDate">{{ 'END' | translate }}</label>
                                <input type="date" [readonly]="datesReadonly" formControlName="stopDate"
                                    class="form-control form-date date-custom mb-2"
                                    [ngClass]="{ 'is-invalid': reportformsubmitted && reportForm.controls.stopDate.errors }" />
                                <div *ngIf="reportformsubmitted && reportForm.controls.stopDate.errors" class="invalid-feedback">
                                    <div *ngIf="reportForm.controls.stopDate.errors.required">{{ 'SELECT_PERIOD' | translate }}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row g-3 align-items-center mb-3 rollup-form-row">
                <label class="col-12 col-xl-2 mb-2 rollup-form-label">{{ 'PLATFORMS_LABEL' | translate }}</label>
                <div class="col-12 col-xl-10">
                    <button type="button" class="gray-button gray-button--toggle rollup-selection-button">
                        <label class="gray-button__toggle-content" for="AllPlatforms">
                            <input type="radio" value="All" name="platforms" formControlName="platforms"
                                id="AllPlatforms" checked (change)="handlePlatformsChange($event, 'All')">
                            {{ 'ALL' | translate }}
                        </label>
                    </button>
                    <button *ngFor="let platform of platforms" type="button" class="gray-button gray-button--toggle rollup-selection-button">
                        <label class="gray-button__toggle-content" for="platform_{{ platform }}">
                            <input type="radio" [value]="platform" name="platforms"
                                formControlName="platforms" id="platform_{{ platform }}"
                                (change)="handlePlatformsChange($event, platform)">
                            {{ platform | translate }}
                        </label>
                    </button>
                </div>
            </div>
            <div class="row g-3 align-items-center mb-3 rollup-form-row">
                <label class="col-12 col-xl-2 mb-2 rollup-form-label">{{ 'AGGREGATION' | translate }}</label>
                <div class="col-12 col-xl-10">
                    <button type="button" class="gray-button gray-button--toggle rollup-selection-button">
                        <label class="gray-button__toggle-content" for="AggregateAll">
                            <input type="radio" value="All" name="aggregation"
                                formControlName="aggregation" id="AggregateAll" checked
                                (change)="handleAggregateChange($event, false)">
                            {{ 'ALL' | translate }}
                        </label>
                    </button>
                    <button type="button" class="gray-button gray-button--toggle rollup-selection-button">
                        <label class="gray-button__toggle-content" for="SelectCampaigns">
                            <input type="radio" value="SelectCampaigns" name="aggregation"
                                formControlName="aggregation" id="SelectCampaigns" (change)="handleAggregateChange($event, true)">
                            {{ 'SELECT_CAMPAIGNS' | translate }}
                        </label>
                    </button>
                </div>
            </div>
            <div class="row g-3 align-items-center mb-0 rollup-form-row">
                <label class="col-12 col-xl-2 mb-2 rollup-form-label"></label>
                <div class="col-12 col-xl-10 rollup-company-actions">
                    <button type="submit" class="blue-button">{{ 'VIEW_ROLLUP_REPORT' | translate }}</button>
                </div>
            </div>
        </form>

        <div *ngIf="SelectCampaignsError" class="text-danger rollup-company-error">
            {{ SelectCampaignsError | translate }}
        </div>
    </div>

    <div class="rollup-report-settings-toolbar" *ngIf="showReportOnly">
        <button type="button" class="gray-button" (click)="showReportSettings()">{{ 'REPORT_SETTINGS' | translate }}</button>
    </div>

    <div class="dv-custom-navs rollup-company-tabs datatable-page-surface" *ngIf="!showReportOnly">
        <ul ngbNav #nav="ngbNav" [(activeId)]="active" class="nav-tabs details-nav-tabs" (activeIdChange)="onTabChange($event)">
            <li [ngbNavItem]="1" [class.rm-tab-active]="active === 1">
                <a ngbNavLink>
                    <i-feather name="check"></i-feather><label>{{ 'CAMPAIGNS' | translate }}</label>
                </a>
                <ng-template ngbNavContent>
                    <div class="details-tab-panel">
                        <div class="details-tab-panel__surface details-tab-surface details-tab-surface--tight">
                            <app-special-datatable [iShowDropdownAdd]="false" [iShowSelect]="showCampaignSelection"
                                [iShowActions]="false" [iShowExport]="false" [iColumns]="columns" [iCanRead]="doWhat.canRead"
                                [iCanWrite]="doWhat.canWrite" [iData$]="(filteredCampaignsData | async) ?? []"
                                (oCBClick)="onSelectCheckboxChange($event)"></app-special-datatable>
                        </div>
                    </div>
                </ng-template>
            </li>
            <li [ngbNavItem]="2" [class.rm-tab-active]="active === 2" *ngIf="rollupReportDataResponse?.orderId">
                <a ngbNavLink>
                    <i-feather name="file-text"></i-feather><label>{{ 'PROGRESS' | translate }}</label>
                </a>
                <ng-template ngbNavContent>
                    <div class="details-tab-panel">
                        <div class="details-tab-panel__surface details-tab-surface details-tab-surface--tight">
                            <app-reports-rollup-report-view-progress (oDataLoadCompleted)="DataLoadCompleted($event)"
                                [iRollupReportDataResponse]="rollupReportDataResponse">
                            </app-reports-rollup-report-view-progress>
                        </div>
                    </div>
                </ng-template>
            </li>
            <li [ngbNavItem]="3" [class.rm-tab-active]="active === 3" *ngIf="rollupReportDataResponse?.orderId && dataLoadCompleted">
                <a ngbNavLink>
                    <i-feather name="file-text"></i-feather><label>{{ 'REPORT_VIEW' | translate }}</label>
                </a>
                <ng-template ngbNavContent>
                    <div class="details-tab-panel">
                        <div class="details-tab-panel__surface details-tab-surface details-tab-surface--report">
                            <app-reports-rollup-report-view
                                [iRollupReportDataResponse]="rollupReportDataResponse"
                                [iRawReports]="rollupReportRawData">
                            </app-reports-rollup-report-view>
                        </div>
                    </div>
                </ng-template>
            </li>
        </ul>
        <div class="details-nav-outlet" [ngbNavOutlet]="nav"></div>
    </div>

    <div class="details-tab-surface details-tab-surface--report rollup-report-only-surface" *ngIf="showReportOnly">
        <app-reports-rollup-report-view
            [iRollupReportDataResponse]="rollupReportDataResponse"
            [iRawReports]="rollupReportRawData">
        </app-reports-rollup-report-view>
    </div>
</div>
